module.exports = __webpack_public_path__ + "static/media/Bungee-Regular.259d4afa.ttf";